import posthog from "posthog-js";
import { useEffect, useMemo } from "react";
import { ProfileFragment } from "../graphql/profile/profile.fragment";
import { useProfileQuery } from "../graphql/profile/profile.query";
import { useAppSelector } from "../store";

interface Profile {
  profile?: ProfileFragment;
  loading: boolean;
}

export const useProfile = (): Profile => {
  const authenticated = useAppSelector((state) => state.auth.authenticated);
  const email = useAppSelector((state) => state.auth.email);

  const { loading, data, dataState } = useProfileQuery({
    skip: !authenticated,
  });

  const user = dataState === "complete" ? data.user : undefined;

  useEffect(() => {
    if (!user) return;

    posthog.identify(user.id, {
      email: user.email,
      first_name: user.firstName,
      last_name: user.lastName,
    });
  }, [user]);

  const profile = useMemo(() => {
    if (user) {
      return user;
    }

    return {
      email,
    } as ProfileFragment;
  }, [user]);

  return {
    loading,
    profile: profile as ProfileFragment,
  };
};
